<template>
  <div class="home">
    <!-- 头部大图 -->
    <div class="head-img">
      <h3 class="animate__animated wow animate__fadeInLeft">
        为肾脏病患者提供
      </h3>
      <h2 class="animate__animated wow animate__fadeInLeft">
        创新服务 & 优质产品
      </h2>
      <button
        class="Undme animate__animated wow animate__fadeInLeft"
        @click="RouterChangeTo('About')"
      >
        <span>了解我们</span><i class="el-icon-right"></i>
      </button>
      <ul class="infobox">
        <li id="one">
          <h2>30000 +</h2>
          <p>服务病患</p>
        </li>
        <li>
          <h2>232</h2>
          <p>合作专家</p>
        </li>
        <li>
          <h2>512</h2>
          <p>合作医院</p>
        </li>
        <li>
          <h2>208</h2>
          <p>合作伙伴</p>
        </li>
      </ul>
    </div>
    <!-- 淡入展示 -->
    <div class="sketch">
      <div class="sketch-box">
        <div
          class="sketch-box-img animate__animated wow animate__fadeInLeft"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/518C385D5CE14B57B137F365496EDBB9-6-2.png"
            alt=""
          />
        </div>
        <div
          class="sketch-box-text animate__animated wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div class="top">
            <h2>创新服务</h2>
            <p>INNOVATIVE SERVICES</p>
          </div>
          <div class="main main2">精准策划<br />深度运营</div>
          <div class="bottom">
            <button @click="RouterChangeTo('Innovate')">
              更多 <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-text text2 animate__animated wow animate__fadeInLeft"
          data-wow-duration="1s"
        >
          <div class="top toptwo">
            <h2>商业渠道</h2>
            <p>COMMERCIAL CHANNEL</p>
          </div>
          <div class="main maintwo">整合渠道<br />合作共赢</div>
          <div class="bottom">
            <button @click="RouterChangeTo('Business')">
              更多 <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
        <div
          class="sketch-box-img animate__animated wow animate__fadeInRight"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/DC704271794E44C0B18E4DB36A667CD8-6-2.png"
            alt=""
          />
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-img animate__animated wow animate__fadeInLeft"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/BF0713CA242940EAB3CF837F9C63F007-6-2.png"
            alt=""
          />
        </div>
        <div
          class="sketch-box-text animate__animated wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div class="top">
            <h2>工业生产</h2>
            <p>INDUSTRIAL PRODUCTION</p>
          </div>
          <div class="main main2">为健康<br />造好水</div>
          <div class="bottom">
            <button @click="RouterChangeTo('Industry')">
              更多 <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-text text2 animate__animated wow animate__fadeInLeft"
        >
          <div class="top toptwo">
            <h2>医学培训</h2>
            <p>MEDICAL TRAINING</p>
          </div>
          <div class="main maintwo">前沿学术推广<br />基层人才培训</div>
          <div class="bottom">
            <button @click="RouterChangeTo('Science')">
              更多 <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
        <div class="sketch-box-img animate__animated wow animate__fadeInRight">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/AEC2485981104FBB94C6F376C2146E27-6-2.png"
            alt=""
          />
        </div>
      </div>
      <div class="sketch-box">
        <div
          class="sketch-box-img animate__animated wow animate__fadeInLeft"
          data-wow-duration="0.8s"
        >
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/E66F592A44C7490F842357B3AFA31C0D-6-2.png"
            alt=""
          />
        </div>
        <div
          class="sketch-box-text animate__animated wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div class="top top2">
            <h2>信息平台</h2>
            <p>INFORMATION PLATFORM</p>
          </div>
          <div class="main main2">云计算<br />人工智能<br />物联网</div>
          <div class="bottom">
            <button @click="RouterChangeTo('News')">
              更多 <i class="el-icon-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 专家团队 -->
    <div class="team-box animate__animated wow animate__fadeInUp">
      <div class="title">
        <h2>专家团队</h2>
        <p>TEAM OF EXPERTS</p>
      </div>
      <div class="main">
        <div class="main-left">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/B1713C66D7B4424C9D40A28D9580CAEC-6-2.png"
            alt=""
          />
        </div>
        <div class="main-right">
          <div class="team-infobox">
            <div class="icon">
              <img src="../assets/image/home/97.webp" alt="" />
            </div>
            <h3>37名</h3>
            <p>国家级学术团队<br />主委/副主委</p>
          </div>
          <div class="team-infobox gl">
            <div class="icon">
              <img src="../assets/image/home/99.webp" alt="" />
            </div>
            <h3>45名</h3>
            <p>省级学术团队<br />主委/副主委</p>
          </div>
          <div class="team-infobox">
            <div class="icon">
              <img src="../assets/image/home/98.webp" alt="" />
            </div>
            <h3>150名</h3>
            <p>地方中心 <br />主任医师</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partner animate__animated wow animate__fadeInUp">
      <div class="title">
        <h2>合作伙伴</h2>
        <p>COOPERATIVE PARTNER</p>
      </div>
      <div class="partner-menu">
        <!-- 移动端 -->
        <div class="select-menu">
          <el-select v-model="value" placeholder="请选择" @change="toSwitch">
            <el-option
              v-for="item in partnerMenu"
              :key="item.id"
              :label="item.name"
              :value="item.title"
            >
            </el-option>
          </el-select>
        </div>
        <!-- PC端 -->
        <ul>
          <li
            @click="toSwitch(item)"
            v-for="item in partnerMenu"
            :key="item.id"
            :id="item.id === glID ? 'homegl' : ''"
          >
            <div class="icon" v-if="item.id !== glID">
              <img :src="item.icon" alt="" />
            </div>
            <div class="text">{{ item.name }}</div>
          </li>
        </ul>
      </div>
      <ul class="partner-box">
        <li
          :class="glID == 1 || value == 'government' ? 'width' : ''"
          v-for="(item, index) in partnerMenuList"
          :key="index"
        >
          <img :src="item" alt="" />
        </li>
      </ul>
      <div class="PCpage" v-if="glID === 5 || value == 'hospital'">
        <span :class="hospitalGL == 1 ? 'gl' : ''" @click="hospitalChange(1)"
          >1</span
        >
        <span :class="hospitalGL == 2 ? 'gl' : ''" @click="hospitalChange(2)"
          >2</span
        >
      </div>
      <div class="bufen">-{{ message }}-</div>
    </div>
    <!-- 核心团队 -->
    <div class="team">
      <div class="title">
        <h2>核心团队</h2>
        <p>MAIN MEMBERS</p>
      </div>
      <div class="teamcontent">
        <img
          src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/4F3E6076011F4A62A9B85B0221EDC506-6-2.png"
          alt=""
        />
      </div>
      <div class="teamcontentIOS">
        <div class="box">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/54EF01B24F8B4C608737FCACEDB4C377-6-2.png"
            alt=""
          />
          <div class="tit">徐晓东 <span>合伙人</span></div>
        </div>
        <div class="box">
          <img
            src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/397F3C97B74745CA9EE0405FC6B4C712-6-2.png"
            alt=""
          />
          <div class="tit">陈双明 <span>合伙人</span></div>
        </div>
      </div>
      <div class="pclunbo">
        <el-carousel trigger="click" :autoplay="false" arrow="always">
          <el-carousel-item v-for="(item, index) in teamList" :key="index">
            <div class="pic">
              <h2>{{ item.text }}</h2>
              <img :src="item.pic" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="ioslunbo">
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in IosteamList"
              :key="index"
            >
              <div class="pic">
                <div class="title">{{ item.title }}</div>
                <ul class="image">
                  <li v-for="(item2, index) in item.picList" :key="index">
                    <img :src="item2.pic" />
                    <div class="tit">
                      {{ item2.name }}<span>{{ item2.position }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 资质荣誉 -->
    <div class="zizhi animate__animated wow animate__fadeInUp">
      <div class="title">
        <h3>资质荣誉</h3>
        <p>QUALIFICATION HONOR</p>
      </div>
      <div class="lunbo">
        <el-carousel arrow="always" trigger="click" :autoplay="false">
          <el-carousel-item v-for="(item, index) in lunboLists" :key="index">
            <img :src="item" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="lunbo-ios">
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in lunboListsIOS"
              :key="index"
            >
              <img :src="item" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- 底部标语 -->
    <div class="footer-title animate__animated wow animate__fadeIn">
      <div class="title">专业医疗服务机构，为您提供解决方案</div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; // 局部引入swiper
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
export default {
  data() {
    return {
      lunboLists: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/1ED03065705D46008B8176BCFECEDF71-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/590DBA16A6C84606B650702E42D2614E-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/F1C0F6FA5AA943B394102454EEF3E3D2-6-2.png",
      ],
      lunboListsIOS: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/EE6C5CBEFC71449F878A694E40EC32F9-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/1351462659544A4C8A21E0FF759B342A-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/1C5AFCEA734943F5AD5232EE72FB5A7F-6-2.png",
      ],
      value: "服务医院",
      // 管理团队移动轮播
      IosteamList: [
        {
          title: "管理团队",
          picList: [
            {
              name: "万薇",
              position: "副总经理",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/0F27A2F7E3344CEA838E44E67C36A3C4-6-2.png",
            },
            {
              name: "孙剑",
              position: "副总经理",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9ECE16552BC04D07BD45520A8A881A81-6-2.png",
            },
          ],
        },
        {
          title: "总监团队",
          picList: [
            {
              name: "刘小燕",
              position: "销售总监",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2A15C43693974FFB8DA0775DA2E146EC-6-2.png",
            },
            // {
            //   name: "张彬",
            //   position: "医护总监",
            //   pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/3BA6CEDF8D5B42A6A2EFE06D333C0F4A-6-2.png",
            // },
            {
              name: "张士匣",
              position: "采购总监",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/85B32926680B44E0BE3BDA7DADBD8481-6-2.png",
            },
            {
              name: "林新如",
              position: "信息总监",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/004EF066EACF416B9E14346E9015C7AF-6-2.png",
            },
            // {
            //   name: "逯志伟",
            //   position: "销售总监",
            //   pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D6833F7B96344912B17535C2C4839B89-6-2.png",
            // },
          ],
        },
        {
          title: "部门经理",
          picList: [
            {
              name: "李娟",
              position: "办公室主任",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/161DEFA2F7E04C78AAB1273F4563F966-6-2.png",
            },
            {
              name: "刘祥",
              position: "工程管理部经理",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2EF656E023C24D3CA718F9F7963EABC6-6-2.png",
            },
            {
              name: "金弢",
              position: "财务部经理",
              pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/F5834A3C8EAF4AEB8421BDDD78DCB950-6-2.png",
            },
          ],
        },
      ],
      // 管理团队PC轮播
      teamList: [
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D36C7658B4D84A0DB91AB7282A664881-6-2.png",
          text: "管理团队",
        },
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8F9136017CF54B4CABA8B40268CB9FAF-6-2.png",
          text: "总监团队",
        },
        {
          pic: "https://yyt-ows.oss-cn-beijing.aliyuncs.com/E53AB91A775D401887986F7C85ADB82F-6-2.png",
          text: "部门经理",
        },
      ],
      // 合作伙伴下拉框
      partnerMenu: [
        {
          name: "服务医院",
          icon: require("../assets/image/home/228.webp"),
          id: 5,
          title: "hospital",
        },
        {
          name: "生产厂家",
          icon: require("../assets/image/home/1112.webp"),
          id: 4,
          title: "manufactor",
        },
        {
          name: "企业集团",
          icon: require("../assets/image/home/160.webp"),
          id: 3,
          title: "enterprise",
        },
        {
          name: "学会组织",
          icon: require("../assets/image/home/156.webp"),
          id: 2,
          title: "mechanism",
        },
      ],
      glID: 5,
      hospitalGL: 1,
      message: "部分展示",
      partnerMenuList: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8DE119CE691C404D9F1748B96BB3E30C-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/62F5D715A3774F6A80E41DA53078E2F2-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9D144C4C51C443699208A3512395C89D-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/412E2D3BD52E4F21978C50A1B71DAC5A-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/E9E73A80C15340A8804D8CD025D05F09-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8920C6FD32EB4CDEBF66599FE74F0AD2-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/66E2A28CD80E4608A452590C501D120E-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2F781E4DF70A4B4F81D10DF1C982C8DF-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/CF1BA6E85F1343BA962BF23F68374BAD-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/97DD7C2DE925473F925BAB30390A60D5-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D1768D18ABDA4BDBB3CFB13876C853F3-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9473FBD5C07D4FF891179B68DC7B0BDF-6-2.png",
      ],
    };
  },
  watch: {
    glID: function (newVal) {
      if (newVal === 1) {
        this.message = "政府相关单位";
      } else {
        this.message = "部分展示";
      }
    },
    value: function (newVal) {
      if (newVal === "government") {
        this.message = "政府相关单位";
      } else {
        this.message = "部分展示";
      }
    },
  },
  created() {},
  mounted() {
    new Swiper(".mySwiper", {
      spaceBetween: 30,
      pagination: ".swiper-pagination",
    });
  },
  methods: {
    // 医院切换
    hospitalChange(id) {
      this.hospitalGL = id;
      if (id === 2) {
        this.partnerMenuList = [
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/441506052E6D46729B889242D1819562-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/F45CC5CDCA1847888ECF7B7352FB9C61-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/69C4DC79275048239469491A7D8B262D-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/6D96ECF4798547F9ABE11C66D1B3EBE3-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/5C2E56C3CB4E40EBA5DD686CED9420CD-6-2.png",
        ];
      } else {
        this.partnerMenuList = [
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8DE119CE691C404D9F1748B96BB3E30C-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/62F5D715A3774F6A80E41DA53078E2F2-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9D144C4C51C443699208A3512395C89D-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/412E2D3BD52E4F21978C50A1B71DAC5A-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/E9E73A80C15340A8804D8CD025D05F09-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8920C6FD32EB4CDEBF66599FE74F0AD2-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/66E2A28CD80E4608A452590C501D120E-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2F781E4DF70A4B4F81D10DF1C982C8DF-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/CF1BA6E85F1343BA962BF23F68374BAD-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/97DD7C2DE925473F925BAB30390A60D5-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D1768D18ABDA4BDBB3CFB13876C853F3-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9473FBD5C07D4FF891179B68DC7B0BDF-6-2.png",
        ];
      }
    },
    // 合作伙伴切换
    toSwitch(item) {
      this.glID = item.id;
      if (item.title == "mechanism" || this.value == "mechanism") {
        // 学会组织
        this.partnerMenuList = [
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/4506A2666B624B55B8FE4D1779F3DC99-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/7EB1BDFC78C2457F9B2A41038D727783-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/97C9BF71D53341EA8C96BA172A57BC37-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/E831C31F25D045A2A2CAC71FB0267F5D-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/BC263C67041943FCBC359D88694525D1-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8FA017D74DC04ABC8E08635E5A70C837-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/3B50EAED16184D4DAEC9FC8D7E410FDD-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9751435E21474AE481DBB9983567D629-6-2.png",
        ];
      } else if (item.title == "enterprise" || this.value == "enterprise") {
        // 企业集团
        this.partnerMenuList = [
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D4ED7D8C2E254BF080D934CD646A17D3-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8681EEDD5901417797EC55ED9F75C749-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/39021EE6E38E4818AF2A429362B61B1F-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/3AF99EAE087143668D67A04FF0E5AB60-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/FA2BA6B4AF594F778772DB84806F63FD-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2485E1FBB277452F8B14845BBE319275-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/51643AE22E2C4210BD6934670948797C-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/CE00C146457045CFB14D1D4E07B80823-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/0DA659FC78AD474FBD433B7777FF0BAE-6-2.png",
        ];
      } else if (item.title == "manufactor" || this.value == "manufactor") {
        // 生产厂家
        this.partnerMenuList = [
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/80D804D836F0434A8C30786B3351ED22-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2887B54002AF4FD7BB999C8A0D8363DB-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9C24D85F55404EF688FA51A20F1BDFEB-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/22D9818235B64459B4144A73CB262081-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/BF95EE6B1E2749C88D45FCB3CC0049F1-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/A8BC02C0AA254B92920248C34AC080F3-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/DFFEF25E046A44EEAD0F30347C52E61F-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/F09B47B46ACF4523B3B0375AD50FC8B2-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/BC8FB1A0E9EC4EE8BC115461AF43AEDA-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D5D086C9E79E418C954FB84FA9A67B3B-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/58AE8F2A6F694C488B4137CED402D5C2-6-2.png",
        ];
      } else if (item.title == "hospital" || this.value == "hospital") {
        // 服务医院
        this.hospitalGL = 1;
        this.partnerMenuList = [
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8DE119CE691C404D9F1748B96BB3E30C-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/62F5D715A3774F6A80E41DA53078E2F2-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9D144C4C51C443699208A3512395C89D-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/412E2D3BD52E4F21978C50A1B71DAC5A-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/E9E73A80C15340A8804D8CD025D05F09-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/8920C6FD32EB4CDEBF66599FE74F0AD2-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/66E2A28CD80E4608A452590C501D120E-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/2F781E4DF70A4B4F81D10DF1C982C8DF-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/CF1BA6E85F1343BA962BF23F68374BAD-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/97DD7C2DE925473F925BAB30390A60D5-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/D1768D18ABDA4BDBB3CFB13876C853F3-6-2.png",
          "https://yyt-ows.oss-cn-beijing.aliyuncs.com/9473FBD5C07D4FF891179B68DC7B0BDF-6-2.png",
        ];
      }
    },
    RouterChangeTo(path) {
      this.$router.push({ name: path });
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  .width {
    width: 500px !important;
    @media screen and (max-width: 540px) {
      width: 100% !important;
    }
  }
  .toptwo {
    text-align: left !important;
    padding-left: 1.7021rem !important;
  }
  .maintwo {
    padding-left: 3.4043rem !important;
  }
  #homegl {
    position: relative;
    background-color: #0ca6eb !important;
    .text {
      color: #fff !important;
    }
  }
  #homegl ::after {
    position: absolute;
    bottom: -0.1064rem;
    left: 48%;
    content: "";
    width: 0;
    height: 0;
    border: 0.1064rem solid #0ca6eb;
    border-bottom: none;
    // border-top: none;
    border-left-color: transparent;
    border-right-color: transparent;
    // background-color: #0ca6eb;
  }
  // <!-- 头部大图 -->

  .head-img {
    height: 8.4043rem;
    width: 100%;
    background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/26CCDB7C99054356B47F169C53D968D1-6-2.png")
      no-repeat;
    background-size: 100% 100%;
    padding-left: 2.0213rem;
    box-sizing: border-box;
    position: relative;
    @media screen and (max-width: 540px) {
      height: 280px;
      background-size: cover;
      background-position: 60% 10%;
      padding-left: 1.0526rem;
    }
    h3 {
      padding: 1.5957rem 0 0.2023rem 0;
      font-size: 0.9149rem;
      text-align: left;
      font-weight: 500;
      color: #ffffff;
      margin: 0;
      @media screen and (max-width: 540px) {
        font-size: 1.2632rem;
      }
    }
    h2 {
      font-size: 0.9149rem;
      text-align: left;
      font-weight: 800;
      padding: 0;
      margin: 0;
      color: #ffffff;
      @media screen and (max-width: 540px) {
        font-size: 1.2632rem;
      }
    }
    .Undme {
      cursor: pointer;
      margin-top: 0.7106rem;
      width: 3.5319rem;
      height: 0.9149rem;
      background: rgba(255, 255, 255, 0);
      border: 0.0213rem solid #ffffff;
      border-radius: 0.4787rem;
      font-size: 0.3723rem;
      color: #fff;
      @media screen and (max-width: 540px) {
        width: 5.2632rem;
        height: 1.3579rem;
        border-radius: 0.6842rem;
        span {
          font-size: 12px;
        }
      }
    }
    .infobox {
      position: absolute;
      height: 2.6702rem;
      width: 18.3617rem;
      background-color: #fff;
      left: 0;
      bottom: -2.1553rem;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 0.2128rem;
      @media screen and (max-width: 540px) {
        padding-left: 0;
        width: 80%;
        left: 50%;
        margin-left: -40%;
      }
      #one {
        border: none;
      }
      li {
        width: 3.9043rem;
        height: 1.5426rem;
        text-align: center;
        border-left: 1px solid #e2e2e2;
        h2 {
          font-size: 0.5957rem;
          padding-top: 0.1064rem;
          text-align: center;
          color: #333;
          font-weight: 600;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
          // letter-spacing: -2.13px;
        }
        p {
          font-size: 0.3191rem;
          margin: 0;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
          color: #0ca6eb;
        }
      }
    }
  }
  // <!-- 淡入展示 -->
  .sketch {
    padding-top: 2.5532rem;
    background-color: #fbfbfb;
    div{
      overflow: hidden;
    }
    .sketch-box {
      height: 8.8936rem;
      display: flex;
      padding: 15px;
      @media screen and (max-width: 540px) {
        display: block;
        position: relative;
        z-index: 10;
        height: 12.6316rem;
      }
      .sketch-box-img {
        flex: 1;
        height: 100%;
        @media screen and (max-width: 540px) {
          flex: none;
          width: 100%;
          overflow: hidden;
        }
        img {
          width: 100%;
          height: 100%;
          @media screen and (max-width: 540px) {
            height: 120%;
          }
        }
        // background-size: 100% 100%;
      }
      .text2 {
        @media screen and (max-width: 540px) {
          position: absolute;
          width: 50%;
          left: 0;
          top: 0;
          background-color: #ffffff77;
          flex: none;
          z-index: 10;
        }
      }
      .sketch-box-text {
        flex: 1;
        @media screen and (max-width: 540px) {
          position: absolute;
          width: 50%;
          right: 0;
          top: 0;
          background-color: #ffffff77;
          flex: none;
        }
        height: 100%;
        .top2 {
          padding: 1.0638rem 1.7021rem 1.0526rem 0 !important;
        }
        .top {
          padding: 1.0638rem 1.7021rem 1.7021rem 0;
          text-align: right;
          h2 {
            font-size: 0.5745rem;
            @media screen and (max-width: 540px) {
              font-size: 1.1579rem;
            }
            color: #334046;
            font-weight: 700;
            margin: 0;
            padding-bottom: 0.2128rem;
          }
          p {
            font-size: 0.2553rem;
            color: #dadbdb;
            @media screen and (max-width: 540px) {
              font-size: 0.5263rem;
            }
          }
        }
        .main2 {
          @media screen and (max-width: 540px) {
            padding-right: 1.7021rem;
            padding-left: 0;
            text-align: right;
          }
        }
        .main {
          padding-bottom: 1.7021rem;
          padding-left: 1.7021rem;
          font-size: 0.4681rem;
          color: #272b2d;
          line-height: 0.8511rem;
          @media screen and (max-width: 540px) {
            font-size: 0.9474rem;
            line-height: 1.2632rem;
            font-weight: 500;
          }
        }
        .bottom {
          text-align: right;
          padding-right: 1.7021rem;
          button {
            cursor: pointer;
            list-style: none;
            width: 2.5532rem;
            height: 0.7447rem;
            background: rgba(255, 255, 255, 0);
            border: 1px solid #0ca6eb;
            border-radius: 0.0638rem;
            font-size: 0.2553rem;
            @media screen and (max-width: 540px) {
              width: 5.2632rem;
              font-size: 12px;
              height: 1.4737rem;
              background-color: #0ca6eb;
              color: #fff;
            }
            color: #0ca6eb;
            i {
              padding-left: 0.766rem;
            }
          }
        }
      }
    }
  }
  // 专家团队
  .team-box {
    .title {
      // height: 3.617rem;
      box-sizing: border-box;
      padding: 1.7021rem 0 0 1.7021rem;
      padding-bottom: 0.9474rem;
      @media screen and (max-width: 540px) {
        padding-left: 0;
        padding-bottom: 0;
      }
      h2 {
        font-size: 0.5745rem;
        color: #334046;
        font-weight: 700;
        margin: 0;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 1.0526rem;
        }
        padding-bottom: 0.2128rem;
      }
      p {
        font-size: 0.2553rem;
        color: #dadbdb;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 0.5263rem;
        }
      }
    }
    .main {
      overflow: hidden;
      .main-left {
        height: 6.5957rem;
        float: left;
        width: 56%;
        img {
          width: 100%;
          height: 100%;
        }
        @media screen and (max-width: 540px) {
          float: none;
          width: 100%;
          height: 10.5263rem;
          padding: 0 15px;
          box-sizing: border-box;
          padding-bottom: 0;
        }
      }
      .main-right {
        height: 6.5957rem;
        float: left;
        width: 44%;
        display: flex;
        @media screen and (max-width: 540px) {
          float: none;
          width: 100%;
          height: 8.4211rem;
          padding: 15px;
          box-sizing: border-box;
          padding-top: 0;
        }
        .gl {
          background-color: #f1f1f1 !important;
        }
        .team-infobox {
          padding-left: 0.3511rem;
          flex: 1;
          background-color: #fbfbfb;
          text-align: left;
          @media screen and (max-width: 540px) {
            text-align: center;
          }
          .icon {
            padding-top: 1.883rem;
            width: 0.4787rem;
            height: 0.4787rem;
            @media screen and (max-width: 540px) {
              margin: auto;
              width: 0.9474rem;
              height: 0.9474rem;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          h3 {
            padding: 0.6383rem 0 0.4255rem 0;
            font-size: 0.4468rem;
            @media screen and (max-width: 540px) {
              font-size: 0.8421rem;
            }
            color: #334046;
            margin: 0;
          }
          p {
            font-size: 0.2979rem;
            color: #666666;
            @media screen and (max-width: 540px) {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  // 核心团队
  .team {
    background-color: #fbfbfb;
    padding-bottom: 1.2632rem;
    .teamcontent {
      padding: 0 1.0526rem;
      text-align: center;
      padding-bottom: 0.8526rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
      img {
        @media screen and (max-width: 540px) {
          width: 100%;
        }
      }
      h2 {
        font-size: 0.3789rem;
        text-align: center;
        padding-top: 0.5263rem;
        @media screen and (max-width: 540px) {
          font-size: 15px;
        }
      }
    }
    .teamcontentIOS {
      padding: 0 15px;
      text-align: center;
      display: none;
      .box {
        margin: 5px 20px;
        box-sizing: border-box;
        height: 210px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .tit {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 40px;
          background-color: #0ca6ebd6;
          color: #fff;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
          font-weight: 600;
          span {
            font-size: 15px;
            padding: 0 4px;
            font-weight: 400;
          }
        }
      }
      @media screen and (max-width: 540px) {
        display: block;
      }
    }
    .title {
      // height: 3.617rem;
      box-sizing: border-box;
      padding: 1.0526rem 0 0 1.7021rem;
      padding-bottom: 0.6316rem;
      @media screen and (max-width: 540px) {
        padding-left: 0;
      }
      h2 {
        font-size: 0.5745rem;
        color: #334046;
        font-weight: 700;
        margin: 0;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 1.0526rem;
        }
        padding-bottom: 0.2128rem;
      }
      p {
        font-size: 0.2553rem;
        color: #dadbdb;
        @media screen and (max-width: 540px) {
          text-align: center;
          font-size: 0.5263rem;
        }
      }
    }
    .pclunbo {
      @media screen and (max-width: 540px) {
        display: none;
      }
      /deep/ .el-carousel {
        padding-bottom: 1.0526rem;
      }
      /deep/.el-carousel__container {
        height: 4.6rem;
      }
      /deep/.el-carousel__indicators--horizontal {
        bottom: 50px;
      }
      /deep/ .el-carousel__arrow {
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
      }
      /deep/ .el-carousel__arrow--left {
        left: 8%;
      }
      /deep/ .el-carousel__arrow--right {
        right: 8%;
      }
      .el-carousel__item {
        overflow: hidden;
        display: flex;
        height: 3.8rem;
        padding-bottom: 0.7263rem;
        justify-content: center;
        .pic {
          position: relative;
          width: 70%;
          height: 100%;
          box-sizing: border-box;
          margin: 0 0.0842rem;
          h2 {
            text-align: center;
            font-size: 0.2737rem;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .txtbox {
            position: absolute;
            bottom: -0.6316rem;
            width: 80%;
            left: 10%;
            background: url("../assets/image/home/team/bg.webp") no-repeat;
            background-size: 100% 100%;
            height: 1.3684rem;
            .allbox {
              width: 100%;
              height: 100%;
              p {
                padding: 0.1684rem 0 0.1474rem 0;
                color: #272b2d;
                text-align: center;
                font-size: 0.3158rem;
              }
              h2 {
                color: #0ca6eb;
                text-align: center;
                font-size: 0.3158rem;
                margin: 0;
              }
            }
            .box {
              h2 {
                font-size: 0.2737rem;
                color: #272b2d;
                text-align: center;
                span {
                  color: #0ca6eb;
                  padding: 0 0.1895rem;
                }
              }
              p {
                color: #272b2d;
                text-align: center;
                font-size: 0.1895rem;
                @media screen and (max-width: 540px) {
                  font-size: 12px;
                }
              }
            }
          }
        }

        .pic1 {
          margin-left: -3.1579rem;
        }
        .pic4 {
          margin-right: -3.1579rem;
        }
      }
      /deep/.el-carousel__button {
        background-color: #e8e8e8;
        height: 0.1053rem;
        width: 0.3158rem;
      }
      /deep/ .is-active {
        button {
          background-color: #0ca6eb;
        }
      }
    }
    .ioslunbo {
      display: none;
      padding: 0 15px;
      position: relative;
      overflow: hidden;
      @media screen and (max-width: 540px) {
        display: block;
        margin-top: 20px;
      }
      .swiper {
        width: 100%;
        height: 100%;
        padding-bottom: 30px;
      }

      .swiper-slide {
        text-align: center;
        font-size: 18px;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }

      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .swiper-pagination {
        bottom: 0px;
        /deep/ .swiper-pagination-bullet {
          width: 11px !important;
          height: 11px !important;
        }
      }

      .pic {
        position: relative;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        margin: 0 0.0842rem;
        .title {
          font-size: 18px;
          text-align: center;
          font-weight: 600;
        }
        .image {
          display: flex;
          flex-wrap: wrap;
          // justify-content: center;
          li {
            position: relative;
            height: 210px;
            flex-basis: 50%;
            padding: 5px;
            box-sizing: border-box;
            img {
              width: 100%;
              height: 100%;
            }
            .tit {
              position: absolute;
              bottom: 5px;
              left: 5px;
              width: 95%;
              height: 30px;
              background-color: #0ca6ebd6;
              color: #fff;
              text-align: center;
              line-height: 30px;
              font-size: 12px;
              font-weight: 600;
              span {
                font-size: 12px;
                padding: 0 4px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
  // 合作伙伴
  .partner {
    background-color: #fbfbfb;
    .title {
      height: 3.617rem;
      box-sizing: border-box;
      padding: 1.7021rem 0 0 1.7021rem;
      @media screen and (max-width: 540px) {
        height: 5.2632rem;
        text-align: center;
        padding-left: 0;
      }
      h2 {
        font-size: 0.5745rem;
        color: #334046;
        font-weight: 700;
        margin: 0;
        padding-bottom: 0.2128rem;
        @media screen and (max-width: 540px) {
          font-size: 1.0526rem;
        }
      }
      p {
        font-size: 0.2553rem;
        color: #dadbdb;
        @media screen and (max-width: 540px) {
          font-size: 0.5263rem;
        }
      }
    }
    .partner-menu {
      padding: 0.2128rem 0 0.617rem 0;
      .select-menu {
        display: none;
        @media screen and (max-width: 540px) {
          display: flex;
          justify-content: center;
        }
      }
      ul {
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: center;
        @media screen and (max-width: 540px) {
          display: none;
        }
        li {
          width: 2.766rem;
          border-radius: 6px;
          height: 0.8298rem;
          display: flex;
          border: 1px solid #eaeaea;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin: 0 0.266rem;
          .icon {
            height: 0.3936rem;
            padding-right: 0.1064rem;
            width: 0.3404rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .text {
            color: #666666;
            font-size: 0.383rem;
          }
        }
      }
    }
    .PCpage {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .gl {
        background-color: #0ca6eb;
        color: #fff;
      }
      span {
        display: block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #eee;
        text-align: center;
        cursor: pointer;
        margin: 0 5px;
        border-radius: 4px;
      }
      // span:hover{
      //     background-color: #eee;
      //   }
    }
    .partner-box {
      padding: 0 1.5957rem;
      overflow: hidden;
      li {
        // flex: 25%;.
        background-color: #fff;
        float: left;
        overflow: hidden;
        width: 3.9362rem;
        height: 1.4043rem;
        border: 1px solid #eeeeee;
        // text-align: center;
        // line-height: 2rem;
        margin: 0.0851rem;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (max-width: 540px) {
          width: 46%;
          height: 3.1579rem;
          margin: 0.2105rem;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    .bufen {
      padding: 0.4211rem 0 1.0316rem 0;
      text-align: center;
      color: #999999;
      font-size: 0.3158rem;
    }
  }
  // 底部标语
  .footer-title {
    height: 2.1579rem;
    width: 100%;
    background: url("../assets/image/home/footer.webp") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 540px) {
      height: 5.2632rem;
    }
    .title {
      text-align: center;
      // padding: 0.3936rem 0;
      box-sizing: border-box;
      border: 2px solid #ffffff;
      background: rgba(255, 255, 255, 0.06);
      font-size: 0.2979rem;
      // height: 1.0638rem;
      line-height: 1.0638rem;
      padding: 0 0.5263rem;
      color: #fff;
      // width: 7.0213rem;
      border-color: rgba(255, 255, 255, 0.6);
      @media screen and (max-width: 540px) {
        font-size: 0.7158rem;
        padding: 0.8421rem;
      }
    }
  }
  // 资质荣誉
  .zizhi {
    background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/92EE451DCF2D4255974AD5033C1727F5-6-2.png")
      no-repeat;
    background-size: 100% 100%;
    padding: 0 1.6842rem;
    padding-bottom: 2.1053rem;
    @media screen and (max-width: 540px) {
      padding: 0;
    }
    .title {
      padding: 1.6842rem 0 1.4737rem 0;
      @media screen and (max-width: 540px) {
        text-align: center;
      }
      h3 {
        color: #334046;
        font-size: 0.5684rem;
        padding-bottom: 0.2105rem;
        margin: 0;
        @media screen and (max-width: 540px) {
          font-size: 25px;
        }
      }
      p {
        font-size: 0.2526rem;
        color: #dadbdb;
      }
    }
    .lunboios {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
      }
      margin: 0 auto;
      width: 100%;
      height: 220px;
      padding-bottom: 50px;
      .el-carousel__item {
        text-align: center;
      }
      .el-carousel__item img {
        height: 99%;
        width: 40%;
        @media screen and (max-width: 540px) {
          width: 90%;
        }
      }
      // /deep/ .el-carousel__item--card {
      //   width: 2.6947rem;
      // }
      /deep/ .el-carousel__arrow {
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
        @media screen and (max-width: 540px) {
          height: 25px;
          width: 25px;
        }
      }
      /deep/ .el-carousel--horizontal {
        padding: 0 50px;
      }
      /deep/ .el-carousel__arrow--left {
        left: -50px;
      }
      /deep/ .el-carousel__arrow--right {
        right: -50px;
      }
      /deep/ .el-carousel__container {
        height: 3.8105rem;
        @media screen and (max-width: 540px) {
          height: 200px;
          // width: 80%;
        }
      }
      /deep/ .el-carousel__item {
        left: -25px;
      }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        @media screen and (max-width: 540px) {
          width: 15px;
          height: 5px;
        }
        background-color: #c3c3c3;
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
        @media screen and (max-width: 540px) {
          padding: 0 5px;
        }
        padding-top: 1.0526rem;
      }
    }
    .lunbo {
      position: relative;
      height: 5.4211rem;
      // margin-bottom: 2.1053rem;
      @media screen and (max-width: 540px) {
        display: none;
        height: 270px;
        padding-bottom: 30px;
      }
      .el-carousel__item img {
        height: 100%;
        width: 100%;
      }
      /deep/ .el-carousel__container {
        height: 90%;
      }
      /deep/ .el-carousel__item {
        width: 100%;
      }
      /deep/ .el-carousel {
        padding: 0 0.8211rem;
        @media screen and (max-width: 540px) {
          padding: 0 20px;
        }
      }
      /deep/ .el-carousel__arrow {
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
        @media screen and (max-width: 540px) {
          width: 25px;
          height: 25px;
        }
      }
      /deep/ .el-carousel--horizontal {
        height: 100%;
      }
      /deep/ .el-carousel__arrow--left {
        left: -0.7895rem;
        @media screen and (max-width: 540px) {
          left: -20px;
        }
      }
      /deep/ .el-carousel__arrow--right {
        right: -0.7895rem;
        @media screen and (max-width: 540px) {
          right: -20px;
        }
      }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        background-color: #c3c3c3;
        @media screen and (max-width: 540px) {
          width: 20px;
          height: 4px;
        }
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
        @media screen and (max-width: 540px) {
          padding: 0 4px;
        }
        padding-top: 0.3158rem;
      }
    }
    .lunbo-ios {
      display: none;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      .swiper-slide {
        padding: 0 10px;
        box-sizing: border-box;
      }
      .swiper {
        padding-bottom: 30px;
        position: relative;
      }
      /deep/ .swiper-pagination-bullet {
        width: 11px !important;
        height: 11px !important;
      }
      @media screen and (max-width: 540px) {
        display: block;
      }
    }
  }
}
</style>
